const B24_PRICES = [
    {
        id: 'SegmentPrice-29',
        type: 'SegmentPrice',
        product_code: 'B24',
        material_type: 'textured',
        width: 24,
        price: 1000
    },
    {
        id: 'SegmentPrice-30',
        type: 'SegmentPrice',
        product_code: 'B24',
        material_type: 'economy',
        width: 24,
        price: 1000
    }
];
export const migrateToV3 = (state)=>{
    const existingKeys = new Set(state.filter((e)=>e.type === 'SegmentPrice').map((e)=>`${e.product_code}-${e.material_type}-${e.width}`));
    const toAdd = B24_PRICES.filter((p)=>!existingKeys.has(`${p.product_code}-${p.material_type}-${p.width}`));
    return [
        ...state,
        ...toAdd
    ];
};

//# sourceMappingURL=v3.js.map